import { ReactElement, useState } from 'react';
import { HeadTag } from 'shared/components';
import { Box } from '@mui/material';
import BiometricDataStatus, {
  ISensitivityType,
} from './components/BiometricDataStatus';
import InputCompanySensitivyType from './components/InputCompanySensitivyType';
import PageHeader from 'shared/components/PageHeader';

const SensitivityPage = (): ReactElement => {
  const [editData, setEditData] = useState<ISensitivityType | null>(null);

  const handleEdit = (type: ISensitivityType): void => {
    setEditData(type);
    // Scroll to the input form
    const inputElement = document.querySelector('.sensitivity-input');
    if (inputElement) {
      inputElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const handleEditComplete = (): void => {
    setEditData(null);
  };

  return (
    <>
      <PageHeader
        title="Manage Sensitivity Types"
        description="Configure data sensitivity classifications for your datasets. Global types are available to all companies and cannot be deleted."
      />
      <Box className="ai-inventory sensitivity-types">
        <HeadTag title="Sensitivity Types" />

        <Box className="sensitivy-manage-wrapper">
          <BiometricDataStatus onEdit={handleEdit} />
          {editData && (
            <InputCompanySensitivyType
              editData={editData}
              onEditComplete={handleEditComplete}
            />
          )}
          {!editData && (
            <InputCompanySensitivyType
              editData={editData}
              onEditComplete={handleEditComplete}
            />
          )}
        </Box>
      </Box>
    </>
  );
};

export default SensitivityPage;
